//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_piOverSix = 0.5235987755982988;\n\
";
